export default function AnthropicIcon({ size = 25 }) {
  return (
    <svg viewBox="0 0 24 16" overflow="visible" width={size} height={size}>
      <g
        style={{
          transform: 'translateX(13px) rotateZ(0deg)',
          transformorigin: '4.775px 7.73501px',
        }}
        // eslint-disable-next-line react/no-unknown-property
        transformorigin="4.7750020027160645px 7.735011100769043px"
      >
        <path
          shapeRendering="geometricPrecision"
          fill="rgb(24,24,24)"
          fillOpacity="1"
          d=" M0,0 C0,0 6.1677093505859375,15.470022201538086 6.1677093505859375,15.470022201538086 C6.1677093505859375,15.470022201538086 9.550004005432129,15.470022201538086 9.550004005432129,15.470022201538086 C9.550004005432129,15.470022201538086 3.382294178009033,0 3.382294178009033,0 C3.382294178009033,0 0,0 0,0 C0,0 0,0 0,0z"
        ></path>
      </g>
      <g
        style={{
          transform: 'none',
          transformorigin: '7.935px 7.73501px',
        }}
        opacity="1"
        // eslint-disable-next-line react/no-unknown-property
        transformorigin="7.93500280380249px 7.735011100769043px"
      >
        <path
          shapeRendering="geometricPrecision"
          fill="rgb(24,24,24)"
          fillOpacity="1"
          d=" M5.824605464935303,9.348296165466309 C5.824605464935303,9.348296165466309 7.93500280380249,3.911694288253784 7.93500280380249,3.911694288253784 C7.93500280380249,3.911694288253784 10.045400619506836,9.348296165466309 10.045400619506836,9.348296165466309 C10.045400619506836,9.348296165466309 5.824605464935303,9.348296165466309 5.824605464935303,9.348296165466309 C5.824605464935303,9.348296165466309 5.824605464935303,9.348296165466309 5.824605464935303,9.348296165466309z M6.166755199432373,0 C6.166755199432373,0 0,15.470022201538086 0,15.470022201538086 C0,15.470022201538086 3.4480772018432617,15.470022201538086 3.4480772018432617,15.470022201538086 C3.4480772018432617,15.470022201538086 4.709278583526611,12.22130012512207 4.709278583526611,12.22130012512207 C4.709278583526611,12.22130012512207 11.16093635559082,12.22130012512207 11.16093635559082,12.22130012512207 C11.16093635559082,12.22130012512207 12.421928405761719,15.470022201538086 12.421928405761719,15.470022201538086 C12.421928405761719,15.470022201538086 15.87000560760498,15.470022201538086 15.87000560760498,15.470022201538086 C15.87000560760498,15.470022201538086 9.703250885009766,0 9.703250885009766,0 C9.703250885009766,0 6.166755199432373,0 6.166755199432373,0 C6.166755199432373,0 6.166755199432373,0 6.166755199432373,0z"
        ></path>
      </g>
    </svg>
  );
}
